import React from "react";
import BackgroundCover from "../../components/backgroundCover/BackgroundCover";
import TitleWithDescription from "../../components/TitleWithDescription/TitleWithDescription";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import Title from "../../components/Title/Title";
import { useLanguage } from "../../context/LanguageContext";
import { diamondGlassTranslations } from "../../translations/diamondGlassTemplate";

function DiamondGlass() {
    const { language } = useLanguage();
    const t = diamondGlassTranslations[language];

    return (
        <div className="">
            <BackgroundCover
                backgroundHeight={300}
                imagePosition="initial"
                backgroundImage="/images/diamond_glass/diamond_glass_bg.png"
            >
                <div className="absolute top-1/2 left-[10%] -translate-y-1/2 z-10 hidden md:block">
                    <Title
                        firstLine={t.title.firstLine}
                        secondLine={t.title.secondLine}
                        className=""
                        animate={true}
                    />
                </div>
            </BackgroundCover>

            <div className="mx-auto px-4 md:px-0 py-12 md:py-24">
                <div className="block md:hidden mb-8">
                    <Title
                        firstLine={t.title.firstLine}
                        secondLine={t.title.secondLine}
                        className=""
                        animate={true}
                    />
                </div>
                <div className="flex flex-col items-center">
                    <div className="max-w-4xl text-base text-gray-600 leading-relaxed">
                        {t.introduction}
                    </div>
                </div>
            </div>

            <div className="relative w-full overflow-hidden">
                <div className="w-full bg-gradient-to-b from-[#E1D8D3] via-[#FFFFFF] to-[#E1D8D3] pb-12 md:py-12">
                    <div className="mx-auto px-4 md:px-0 md:pt-8 md:space-y-12 max-w-7xl">
                        {t.sections.map((section, index) => (
                            <TimelineSection
                                key={index}
                                title={{
                                    firstLine: " ",
                                    secondLine: " ",
                                }}
                                description={section.description}
                                media={{
                                    type: 'image',
                                    src: `/images/diamond_glass/Synthetic_Diamond_${index + 1}.png`,
                                    alt: `Diamond Glass Process Step ${index + 1}`
                                }}
                                mediaPosition={index % 2 === 0 ? "right" : "left"}
                                showLine={index !== t.sections.length - 1}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DiamondGlass; 